import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { NotificationService } from '../notification/notification.service';
import { HttpClient } from '@angular/common/http';
import { BgfTransaction } from '../../../../backend/src/transactions/transaction.entity';
import { BgfComponent } from '../../../../backend/src/components/entities/component.entity';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-add-stock',
  templateUrl: './add-stock.component.html',
  styleUrl: './add-stock.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AddStockComponent implements OnInit {

  stockForm: FormGroup;
  isSaving: boolean = false;
  fetchedComponent: BgfComponent;
  imageUrl: string | SafeUrl;
  inputOption: 1 | 2 = 1; // 1: pontos mennyiség, 2: súly
  mode: 'add' | 'remove' = 'add';

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<AddStockComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {positive: boolean, componentId: number}
  ) {}

  ngOnInit() {
    this.mode = this.data.positive === false ? 'remove' : 'add';
    this.createStockForm();
    if(this.data.componentId) {
      this.fetchSelectedComponent();
    }
  }

  createStockForm() {
    this.stockForm = new FormGroup({
      'quantity': new FormControl(null),
      'weight': new FormControl(null),
      'comment': new FormControl('')
    });
  }

  fetchComponentImage() {
    //@ts-ignore
    this.http.get<Blob>(`components/images/${this.fetchedComponent.image_file}`, { responseType: 'blob' }).subscribe((res: Blob) => {
      this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
    })
  }

  closeDialog(result: boolean) {
    this.dialogRef.close(result);
  }

  fetchSelectedComponent() {
    this.http.get<BgfComponent>(`components/one/${this.data.componentId}`).subscribe({
      next: (c) => {
        this.fetchedComponent = c;
        if (c.image_file) {
          this.fetchComponentImage();
        }
      },
      error: (e) => {
        console.log(e);
        this.notificationService.show(`Hiba a komponens lekérdezése során!`,"danger");
      }
    })
  }

  get isPositive(): boolean {
    return this.mode === 'add';
  }

  get previewText(): string {
    const raw = this.inputOption === 1
      ? this.stockForm.get('quantity')?.value
      : this.stockForm.get('weight')?.value;
    const value = Math.abs(Number(raw));
    if (raw === null || raw === undefined || `${raw}` === '' || isNaN(value) || value <= 0) {
      return this.inputOption === 1 ? 'Add meg a darabszámot.' : 'Add meg a súlyt grammban.';
    }
    const sign = this.isPositive ? '+' : '−';
    const unit = this.inputOption === 1 ? ' db' : ' g';
    return 'Mentés után ' + sign + value + unit + ' kerül elkönyvelésre.';
  }

  saveStock() {

    if(this.stockForm.invalid) {
      this.notificationService.show("Űrlap kitöltése nem megfelelő!","danger");
      return;
    }

    const formValue = {...this.stockForm.value} as any;
    const hasQuantityInput = formValue.quantity !== null && formValue.quantity !== undefined && `${formValue.quantity}` !== '';
    const hasWeightInput = formValue.weight !== null && formValue.weight !== undefined && `${formValue.weight}` !== '';

    if (this.inputOption === 1 && !hasQuantityInput) {
      this.notificationService.show("Add meg a mennyiséget!","danger");
      return;
    }

    if (this.inputOption === 2 && !hasWeightInput) {
      this.notificationService.show("Add meg a súlyt!","danger");
      return;
    }

    const normalizedQuantity = hasQuantityInput
      ? (this.isPositive ? Math.abs(Number(formValue.quantity)) : -Math.abs(Number(formValue.quantity)))
      : undefined;
    const normalizedWeight = hasWeightInput
      ? (this.isPositive ? Math.abs(Number(formValue.weight)) : -Math.abs(Number(formValue.weight)))
      : undefined;
    const data = {
      component_id: this.data.componentId,
      quantity: this.inputOption === 1 ? normalizedQuantity : undefined,
      weight: this.inputOption === 2 ? normalizedWeight : undefined,
      comment: formValue.comment,
    }

    this.isSaving = true;
    this.http.post<BgfTransaction>('transactions', data).subscribe({
      next: (t) => {
        this.isSaving = false;
        this.notificationService.show(`Tranzakció elmentve! (${t.quantity} db)`, "success");
        this.closeDialog(true);
      },
      error: (e) => {
        console.log(e);
        this.isSaving = false;
        this.notificationService.show(`Mentés sikertelen! ${e.error?.message}`, "danger");
      }
    })

  }
}
